// extracted by mini-css-extract-plugin
export default {"root":"PasswordResetForm_root__6dt2t","password":"PasswordResetForm_password__XKQHw marketplaceModalPasswordMargins"};